export default "__VITE_ASSET__CF$BR768__"